/* eslint-disable react/no-unused-state */
import React, { PropTypes, Component } from 'react'
import merge from 'lodash/merge'
import Filters from 'components/List/components/Filters'
import { getFiscalYearTimestamps } from 'utils/fiscalYear'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./PartnerPlanFilter.scss'),
)

class PartnerPlanRatingVisibilityFilter extends Component {
  static propTypes = {
    filteredData: PropTypes.instanceOf(Array),
    onChangeFilteredData: PropTypes.func,
    onInitFilteredData: PropTypes.func,
    onPlanYearSearchTrigger: PropTypes.func,
    onPlanStageSearchTrigger: PropTypes.func,
    partnerPlanRatingVisibility: PropTypes.object,
  }

  static defaultProps = {
    filteredData: [],
    onChangeFilteredData: null,
    onInitFilteredData: null,
    onPlanYearSearchTrigger: null,
    onPlanStageSearchTrigger: null,
    partnerPlanRatingVisibility: null,
  }

  constructor(props) {
    super(props)
    // this.handleInitFilteredPersonalInfo = this.handleInitFilteredPersonalInfo.bind(this);
    // this.handleChangeFilteredPersonalInfos = this.handleChangeFilteredPersonalInfos.bind(this);
    this.data = []
    this.state = {
      selPlanYear: getFiscalYearTimestamps().current.year,
      selPlanStage: 'interim',
      filters: {
        planYear: getFiscalYearTimestamps().current.year,
        planStage: 'interim',
      },
      filterData: {
        planYear: constants.LIST_DYNAMICFILTERS('Year', this.props.partnerPlanRatingVisibility.planYear),
        planStage: constants.LIST_DYNAMICFILTERS('Stage', constants.PARTNERPLAN_LIST_OPTIONS.STAGE),
      },
    }
  }

  componentDidMount() {
    const filters = this.state.filters
    let filterSelection = ''
    if (sessionStorage.getItem('PlanRatingVisibilityFilterSelection')) {
      filterSelection = JSON.parse(sessionStorage.getItem('PlanRatingVisibilityFilterSelection'))
      if (filterSelection.year) {
        // eslint-disable-next-line react/no-did-mount-set-state
        // this.setState({ selPlanYear: filterSelection.year })
        setTimeout(() => { this.setState({ selPlanYear: filterSelection.year }) }, 800)
      }
      if (filterSelection.stage) {
        // eslint-disable-next-line react/no-did-mount-set-state
        // this.setState({ selPlanStage: filterSelection.stage })
        setTimeout(() => { this.setState({ selPlanStage: filterSelection.stage }) }, 800)
      }
      this.filterPlanRatingVisibility(filterSelection.year, filterSelection.stage)
    }

    const newFilters = merge({}, filters, {
      planYear: (filterSelection ? filterSelection.year : getFiscalYearTimestamps().current.year),
      planStage: (filterSelection ? filterSelection.stage : 'interim'),
    })

    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ filters: newFilters })
  }

  componentWillReceiveProps(nextProps) {
    const { filteredData } = this.props
    this.data = filteredData
    if (nextProps.filteredData !== this.props.filteredData) {
      this.data = nextProps.filteredData
    }
    // this.filterPlanRatingVisibility('2025', 'interim')
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }
    // not in used the component needs this function to not to throw warnings
  }

  _handleChange = (name, value) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }

    this.setState({ search: stateValue.data.value })
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }
    // not in used the component needs this function to not to throw warnings
  }

  filterByPlanYear = (data, filtervalue) => {
    this.props.onPlanYearSearchTrigger(true, filtervalue)
    this.updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTER.YEAR, filtervalue)
    // eslint-disable-next-line eqeqeq
    return data.filter(item => item.year == filtervalue)
  }

  filterByPlanStage = (data, filtervalue) => {
    this.props.onPlanStageSearchTrigger(true, filtervalue)
    this.updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTER.STAGE, filtervalue)
    // eslint-disable-next-line eqeqeq
    return data.filter(item => item.stage == filtervalue)
  }

  filterPlanRatingVisibility = (planYear, planStage) => {
    let filteredinfo = [...new Set(this.props.partnerPlanRatingVisibility.ratingVisibility)]

    if (planYear) {
      filteredinfo = this.filterByPlanYear(filteredinfo, planYear)
    }
    if (planStage) {
      filteredinfo = this.filterByPlanStage(filteredinfo, planStage)
    }

    this.props.onChangeFilteredData(filteredinfo)
  }

  clearFilters = () => {
    this.setState({
      selPlanYear: '',
      selPlanStage: '',
      filters: {
        planYear: null,
        planStage: null,
      },
    })
    sessionStorage.removeItem('PlanRatingVisibilityFilterSelection')
    this.props.onInitFilteredData()
  }

  filter = ({ type = null, value = null }) => {
    const filters = this.state.filters
    const newFilters = merge({}, filters, {
      [type]: value,
    })

    this.setState({ filters: newFilters }, () => {
      /* TODO: please put your filter logic here */
      if (type === 'planYear') {
        this.setState({ selPlanYear: value })
        // update redux code state
        // this.props.setPlanYearFilter(value)
        this.filterPlanRatingVisibility(value, this.state.selPlanStage)
      } else if (type === 'planStage') {
        this.setState({ selPlanStage: value })
        // update redux code state
        // this.props.setPlanStageFilter(value)
        this.filterPlanRatingVisibility(this.state.selPlanYear, value)
      }
    })
  }

  updateFilterSessionObject = (filterBy, filterValue) => {
    let filterSelection = {
      year: '',
      stage: '',
    }
    if (sessionStorage.getItem('PlanRatingVisibilityFilterSelection')) {
      filterSelection = JSON.parse(sessionStorage.getItem('PlanRatingVisibilityFilterSelection'))
    }
    if (filterBy.toLowerCase() === constants.PARTNERPLAN.SEARCHFILTER.YEAR.toLowerCase()) {
      filterSelection.year = filterValue
    }
    if (filterBy.toLowerCase() === constants.PARTNERPLAN.SEARCHFILTER.STAGE.toLowerCase()) {
      filterSelection.stage = filterValue
    }
    sessionStorage.setItem('PlanRatingVisibilityFilterSelection', JSON.stringify(filterSelection))
  }

  render() {
    return (
      <section className={styles.section}>
        <div className={styles.searchinput} />
        <div className={styles.gridfilterelement}>
          <div className={styles.gridchildfilterelement1}>
            <div />
          </div>
          <div className={styles.gridchildfilterelement2}>
            <Filters
              clearFilters={this.clearFilters}
              filter={this.filter}
              filterData={this.state.filterData}
              rules={this.state.filters}
            />
          </div>
        </div>
      </section>
    )
  }
}

export default PartnerPlanRatingVisibilityFilter



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/PartnerPlan/PartnerPlanRatingVisibilityFilter.js